module.exports = __webpack_public_path__ + "static/media/new-portfolio-1.a10faa1d.JPG";